import * as z from "zod"

export const ConfigurationModel = z.object({
  id: z.number().int(),
  created_at: z.date(),
  updated_at: z.date(),
  scope: z.string(),
  name: z.string(),
  value: z.string().nullish(),
})
